var exports = {
  "n": "x52a3aa3b--1d5b8a--link",
};

module.exports = exports;
